import { Organization } from '@models/Organization';
import { Navigate } from 'react-router-dom';

import AlertasList from '@components/Alertas/AlertasList';
import styles from '@styles/screens/PresenteeismTableControlBoard.module.css';
import designSystemStyles from '@shared/styles/designSystemStyles';

interface AlertasScreenProps {
    org: Organization;
}

const AlertasScreen = ({org}: AlertasScreenProps) => {
    if (!org.newFlags?.AlertsWeb) {
        return <Navigate to="/" />;
    }

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                height: "100%",
                minHeight: 0,
                overflow: "hidden",
                boxSizing: "border-box",
                padding: designSystemStyles.paddingLgScreen,
            }}
        >
            <div style={{ flexShrink: 0 }}>
                <h2 className={styles['title']}>
                    {"Alertas".localized()}
                    <p className={styles['sub-title']}>{"Alertas generadas para la organización".localized()}</p>
                </h2>
            </div>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    flex: 1,
                    minHeight: 0,
                    overflow: "hidden",
                    paddingTop: designSystemStyles.paddingLgScreen,
                }}
            >
                <AlertasList orgID={org.id} timezone={org.timezone}/>
            </div>
        </div>
    );
};

export default AlertasScreen
